export const INITIAL_STATE = {
  error: null,
  errorSummary: null,
  loading: false
};